import { Component, Input, Output, EventEmitter, OnChanges, OnDestroy, OnInit, SimpleChanges, TemplateRef, ViewChild } from '@angular/core';
import { MatDialog, MatDialogRef, MatDialogContent, MatDialogActions } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { Subject, Subscription, takeUntil } from 'rxjs';
import { ApprovalList } from 'src/app/models/interface/CAM/approval-management';
import { CamDeleteModel } from 'src/app/models/interface/CAM/baseResponseInterfaces';
import { CamService } from 'src/app/services/camService/cam.service';
import { ApprovalManagementService } from 'src/app/services/dataLayer/CAM/approval-management.service';
import { CompanyManagementService } from 'src/app/services/dataLayer/CAM/company-management.service';
import { ToastrApiService } from 'src/app/shared/common/toastr-api.service';
import { ApprovalContentService } from '../../services/approval-content.service';
import { MatIcon } from '@angular/material/icon';
import { MatFormField, MatSuffix } from '@angular/material/form-field';
import { MatSelect } from '@angular/material/select';
import { MatOption } from '@angular/material/autocomplete';
import { MatTable, MatColumnDef, MatHeaderCellDef, MatHeaderCell, MatCellDef, MatCell, MatHeaderRowDef, MatHeaderRow, MatRowDef, MatRow } from '@angular/material/table';
import { MatTooltip } from '@angular/material/tooltip';
import { MatButton } from '@angular/material/button';
import { CdkScrollable } from '@angular/cdk/scrolling';
import { NgIf, NgFor } from '@angular/common';
import { CamEmptyStateComponent } from '../cam-empty-state/cam-empty-state.component';
import { MatCheckbox } from '@angular/material/checkbox';
import { CompanyManagementContentService } from "../../services/company-management-content.service";

@Component({
  selector: 'app-approval-listing',
  templateUrl: './approval-listing.component.html',
  styleUrls: ['./approval-listing.component.scss'],
  imports: [MatIcon, MatFormField, MatSelect, MatOption, MatSuffix, MatTable, MatColumnDef, MatHeaderCellDef, MatHeaderCell, MatCellDef, MatCell, MatTooltip, MatHeaderRowDef, MatHeaderRow, MatRowDef, MatRow, MatButton, CdkScrollable, MatDialogContent, MatDialogActions, NgIf, CamEmptyStateComponent, NgFor, MatCheckbox]
})
export class ApprovalListingComponent implements OnChanges, OnDestroy, OnInit {
  displayedColumns: string[] = ['Product', 'Workflow Applied On', 'Created On', 'Actions'];
  receivedData: any;
  tableData: any;
  sortBy: string = 'Newest';
  receivedAppliedOnID: any = [];
  heading: string = 'No results found';
  content: string = "We couldn't find what you searched for. Try searching again";
  IsShow: boolean = true;
  searchingApproval: string = '';
  selected: string = 'Newest';
  currentPage: number = 0;
  pageSize: number = 15;
  filteredData: any[] = [];
  paginatedData: any[] = [];
  totalPages: number = 0;
  private readonly subscription!: Subscription;


  commonObjPipes: any = {
    GetAllApprovalManagementData: { pipe: [], all: [] },
    GetAllProduct: { pipe: [], all: [] },
    GetAllRuleAppliedForData: { pipe: [], all: [] },
    GetAllRuleAppliedOnData: { pipe: [], all: [] },
  }

  filterModalRef!: MatDialogRef<any>;
  @ViewChild('selectionWarning') selectionWarning!: TemplateRef<any>;
  currentItem: any;

  @Input() approvalList: ApprovalList[] = []
  @Output() itemDeleted = new EventEmitter<void>();
  private readonly destroy$ =  new Subject<void>();
  dynamicContent:any;
  constructor(
    private readonly router: Router,
    private readonly _CamService: CamService,
    private readonly _MatDialog: MatDialog,
    private readonly _ToastrApiService: ToastrApiService,
    private readonly _CompanyManagementService: CompanyManagementService,
    private readonly _ApprovalManagementService: ApprovalManagementService,
    private readonly contentService: ApprovalContentService, private _companyManagementContentService: CompanyManagementContentService
  ) {

  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['approvalList']) {
      this.filteredData = this.approvalList || [];
      this.currentPage = 0;
      this.updatePagination();
    }
  }

  ngOnInit() {
    this.contentService.content$.pipe(takeUntil(this.destroy$)).subscribe((res:any)=>{
      this.dynamicContent = res;
      this.heading = this.dynamicContent?.['b2b.manageapproval.noresults'] ?? this.heading;
      this.content = this.dynamicContent?.['b2b.manageapproval.tryagain'] ?? this.content;
    })
    this.filteredData = this.approvalList || [];
    this.updatePagination();
    this.loadRuleAppliedOnList()
      this._companyManagementContentService.content$.subscribe((res: any) => {
                  if (res) {
                      this.manageCompanyData = res;
                  }
              });

  }

  updatePagination() {
    this.totalPages = Math.ceil(this.filteredData.length / this.pageSize);
    const start = this.currentPage * this.pageSize;
    const end = start + this.pageSize;
    this.paginatedData = this.filteredData.slice(start, end);
    this.tableData = this.paginatedData;
  }

  nextPage() {
    if (this.currentPage + 1 < this.totalPages) {
      this.currentPage++;
      this.updatePagination();
    }
  }

  prevPage() {
    if (this.currentPage > 0) {
      this.currentPage--;
      this.updatePagination();
    }
  }



  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  onRowClick(element: any) {
    this._ApprovalManagementService.approval_view(element.workFlowType);
  }

  loadRuleAppliedOnList() {
    this._CamService.getRulesAppliedOn().then((res) => {
      let data: any[] = [];
      if (Array.isArray(res?.data)) {
        data = res.data;
      } else if (Array.isArray((res as any)?.data?.data)) {
        data = (res as any).data.data;
      }
      if (!res || res === null || !data || data.length === 0) {
        this._ToastrApiService.show('error', 'No content available in Rule Applied On.');
        this._ApprovalManagementService.errorMessage('No content available in Rule Applied On.','203',this.manageCompanyData?.b2b.managecompany.ccruleapplied || 'Rule Applied On');
        this.bindLists('GetAllRuleAppliedOnData', [])

        return;
      }

      // Force a new array reference so the dialog template updates reliably.
      this.bindLists('GetAllRuleAppliedOnData', [...data]);
      this._ApprovalManagementService.page_landing('Approval Management', this.approvalList.length, 'Approval Management Workflow') //GTM use


    }).catch((error) => {
      this._ToastrApiService.show('error', 'Failed to load Rule Applied On data.');
       this._ApprovalManagementService.errorMessage(error?.message,'203',this.manageCompanyData?.b2b.managecompany.ccruleapplied || 'Rule Applied On');
      this.bindLists('GetAllRuleAppliedOnData', [])
      console.error(error)

    })
  }



  bindLists(key: string, lists: any[]) {
    const safe = Array.isArray(lists) ? lists : [];
    this.commonObjPipes[key].pipe = safe;
    this.commonObjPipes[key].all = safe;
  }

  AddnewApproval() {
    this._CamService.approvalWorkFlowSettingFormData = null;
    this._ApprovalManagementService.approval_add('Add', this.tableData.length)//GTM use
    this.router.navigate(['cam/approval-management/workflow-setting'])

  }

  onEdit(item: any) {
    this._CamService.approvalWorkFlowSettingFormData = null;
    this._ApprovalManagementService.approval_management('Edit', this.tableData.length)//GTM use
    this.router.navigate(['cam/approval-management/workflow-setting', item.workflowId])
  }

  onRemove(item: any) {
    this._ApprovalManagementService.approval_management('Remove', this.tableData.length)//GTM use

    this.currentItem = item;
    this._MatDialog.open(this.selectionWarning, {
      data: item, 
    });
  }




  confirmDelete(item: ApprovalList) {
    this._ApprovalManagementService.approval_remove_success('Confirm')//GTM use
    const request: CamDeleteModel = {
      id: item.workflowId,
      type: 'WorkFlow'
    }

    this._CamService.DeleteCAMitemBytype(request).then((res) => {
      if (res.status == "Success") {
        this._ApprovalManagementService.approval_remove_success('Confirm');//GTM use
        this._ApprovalManagementService.approval_edit_success('Confirm');
        this._ToastrApiService.show('success', res.message);
        this._ToastrApiService.show('success', 'Approval workflow record deleted successfully.');
        this.currentItem = undefined;
        this.filteredData = this.filteredData.filter((x: ApprovalList) => x.workflowId !== item.workflowId);
        this.updatePagination();
        this.itemDeleted.emit();
      }
    }).catch((error) => {
      const errorMessage =
        error?.error?.message ||
        error?.message ||
        'Something went wrong while deleting the Approval work flow. Please try again later.';
      this._ToastrApiService.show('error', errorMessage);
      this._ApprovalManagementService.errorMessage(error?.error?.message,error?.error?.errorCode,'Approval delete');
    })
  }


  CloseDialog(result: boolean) {
    if (result) {
      this.confirmDelete(this.currentItem)
      this._ApprovalManagementService.approval_remove('Proceed');//GTM use
      
    }

    if (!result) {
      this._ApprovalManagementService.approval_remove('Cancel');//GTM use

    }

    this._MatDialog.closeAll(); // Closes the dialog
  }

   gtmSort(){
    this._ApprovalManagementService.approval_management_afterClickSortOnly('Sort','Sort')//GTM use
  }

  applySorting(sortOrder: string) {

    this._ApprovalManagementService.approval_management_afterClickSort('Sort', sortOrder)//GTM use
    this.sortBy = sortOrder;
    this._CamService.getApprovalManagementV1(this.sortBy, '').then((res) => {

      if (!res?.data) {
        this._ToastrApiService.show('error', 'No content available in Approval workflow.');
        this.filteredData = [];
        this.updatePagination();
        return;
      }
      this.filteredData = res.data ?? [];
      this.currentPage = 0;
      this.updatePagination();

    }).catch((error) => {

      console.log(error)
      this._ToastrApiService.show('error', 'Failed to load Approval workflow data.');

    })

  }

  openFilter(template: TemplateRef<any>) {
    this.filterModalRef = this._MatDialog.open(template, { panelClass: 'custom-popup-gen-filter-popup-type', });
    this._ApprovalManagementService.approval_management_filter('Filter')//GTM use

  }

  //not in use
  applySearching() {
    this._CamService.getApprovalManagement('1', 'Air', '', this.sortBy, '', this.searchingApproval, '1', 'GB').then((res) => {
      this.tableData = res.data.GetAllApprovalManagementData;
    }).catch((error) => { })

  }
  disableRightClick(event: MouseEvent): void {
    event.preventDefault();
  }

  onPasteBlocked(event: ClipboardEvent): void {
    event.preventDefault(); // Prevent the paste action
  }

  blockInvalidCharacters(event: KeyboardEvent): void {
    // List of invalid characters that can be used for XSS, SQL injection, or path traversal
    const invalidChars = ['<', '>', '"', "'", '`', ';', '--', '\\', '?', '+', '_', '#', '%', '^', '*', '!', '=', '%', '(', ')', '{', '}',];

    // If the pressed key is in the invalidChars array, prevent the input
    if (invalidChars.includes(event.key)) {
      event.preventDefault(); // Block the invalid character
    }
  }
  filterAppliedOn(event: any, id: any) {

    if (event.checked) {
      if (!this.receivedAppliedOnID.includes(id)) {
        this.receivedAppliedOnID.push(id)
      }
    } else {
      this.receivedAppliedOnID = this.receivedAppliedOnID.filter((ID: any) => ID != id)

    }
  }

  sendWorkAppliedID() {
    this._ApprovalManagementService.approval_management_filterApply(this.receivedAppliedOnID, this.commonObjPipes.GetAllRuleAppliedOnData.pipe)//GTM use

    this._CamService.getApprovalManagementV1(this.sortBy, this.receivedAppliedOnID).then((res) => {

      if (res == null) {
        this.filteredData = []
      } else {
        this.filteredData = res.data ?? []
      }
      this.currentPage = 0;
      this.updatePagination();
    }).catch((error) => {
      console.log(error)
    })

    this.filterModalRef.close();
  }

  isChecked(id: string): boolean {
    return this.receivedAppliedOnID.includes(id);
  }

  get isApplyDisabled(): boolean {
    return !this.receivedAppliedOnID || this.receivedAppliedOnID.length === 0;
  }

  //GTM use
  OnSortbyClick() {
    this._ApprovalManagementService.approval_management_sort('Sort')//GTM use

  }

    manageCompanyData: any = null;
}
